import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import Select from "react-select";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
//New Data table Code Start
import ReactDataTable from "../../../Common/ReactDataTable";
//New Data table Code End

const OnePercentOfferReport = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [discountOffer, setDiscountOffer] = useState([]);
  const [loading, setLoading] = useState(false);

  const firstDayOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    2
  )
    .toISOString()
    .substr(0, 10);
  console.log(firstDayOfMonth);

  const [inputs, setInputs] = useState({
    from: firstDayOfMonth,
    to: new Date().toISOString().substr(0, 10),
    status: "active",
  });

  //Date range end

  const fetchData = async () => {
    try {
      setLoading(true); // Start loading indicator
      const tradeOfferList = await Http.get("/discount-trade-offer-list");
      setDiscountOffer(tradeOfferList.data);
    } catch (error) {
      console.error("Error submitting form:", error); // Log errors
      // Optionally handle errors (e.g., show a toast or alert)
    } finally {
      setLoading(false); // Stop loading indicator
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const cols = [
    { field: "customer.shop_name", header: "Retailer Name" },
    { field: "customer.phone", header: "Phone" },
    { field: "customer.address", header: "Address" },
    {
      field: "total_price_without_discount",
      header: "Actual Order Amount Without Offer",
    },
    { field: "total_price", header: "Order Amount" },
    { field: "discount", header: "Offer Amount" },
    { field: "date", header: "Date" },
    { field: "time", header: "Time" },
    { field: "distributor.name", header: "Distributor" },
    { field: "distributor.code", header: "Distributor Id" },
    { field: "base.name", header: "Base" },
    { field: "area.name", header: "Area" },
    { field: "region.name", header: "Region" },
    { field: "zone.name", header: "Zone" },
  ];

  //Date range start
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = async () => {
    try {
      setLoading(true); // Start loading indicator

      const res = await Http.post("/offer-report", inputs); // Await the HTTP request
      setReceiveData(res.data); // Set the received data
    } catch (error) {
      console.error("Error submitting form:", error); // Log errors
      // Optionally handle errors (e.g., show a toast or alert)
    } finally {
      setLoading(false); // Stop loading indicator
    }
  };
  const selectHandleChange = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  //Date range end
  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">One Percent Offer Report</h5>
            {/* <Link to="/create-distributors" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>New
            </Link> */}
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            {/* Date range start */}
            <div className="card pd-sm-40">
              <div className="row">
                <div className="col-lg">
                  <label htmlFor="">Offer</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    defaultValue={discountOffer[0]}
                    name="offer_id"
                    options={discountOffer}
                    onChange={selectHandleChange}
                  />
                </div>
                <div className="col-lg">
                  <label htmlFor="">From</label>
                  <input
                    type="date"
                    className="form-control"
                    name="from"
                    value={inputs.from || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg">
                  <label htmlFor="">To</label>
                  <input
                    type="date"
                    className="form-control"
                    name="to"
                    value={inputs.to || ""}
                    onChange={handleChange}
                  />
                </div>
                {/* <div className="col-lg">
                  <select
                    className="form-control"
                    name="offer_id"
                    onChange={handleChange}
                  >
                    <option value="">Select Offer</option>
                    <option value="1">স্বাগত অফার</option>
                    <option value="36">ওয়ান পার্সেন্ট অফার</option>
                    <option value="77">৭০০ টাকায় ৫ পার্সেন্ট অফার </option>
                    <option value="78">২০০০ টাকায় ৫ পার্সেন্ট অফার </option>
                    <option value="80">
                      ১০০০ টাকার বেশি কেনাকাটায় ৩% ছাড়
                    </option>
                    <option value="81">
                      ১২৫০ টাকার বেশি কেনাকাটায় ৪% ছাড়
                    </option>
                  </select>
                </div> */}
                <div className="col-lg">
                  <button
                    className="btn btn-primary btn-block mg-b-10 mt-4"
                    onClick={formSubmit}
                  >
                    <i className="fa fa-send mg-r-10"></i> Search
                  </button>
                </div>
              </div>
            </div>
            {/* Date range end */}

            <div className="card">
              <ReactDataTable
                cols={cols}
                isLoading={loading}
                receiveData={receiveData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnePercentOfferReport;
